export const useStaticAssetQuery = groq`
*[_type == "staticAsset" && currentPathname == $currentPathname][0] {
  _id,
  currentPathname,
  "cdnKey": asset.asset._ref,
}
`;
